export default __webpack_public_path__ + "static/media/Screenshot 2024-02-22 at 1.49.02â¯PM.77557fab.png";